import { render } from "./WideImageUploader.vue?vue&type=template&id=ca4534b8"
import script from "./WideImageUploader.vue?vue&type=script&lang=js"
export * from "./WideImageUploader.vue?vue&type=script&lang=js"

import "./WideImageUploader.vue?vue&type=style&index=0&id=ca4534b8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__